import React, { Component } from 'react'
import { connect } from 'react-redux'
import { __ } from '../services/translate'
import NewsItem from '../components/NewsItem'
import { selectNews } from '../utils/selectors/content'
import { initPagination, showPage } from '../actions/content'
import { PaginationButton } from '../components/Common/Pagination'
import { FlexRow } from '../components/Common/Layout'
import { paginate } from '../utils/pagination'

class News extends Component {

  state = {
    total: 0
  }

  static getDerivedStateFromProps(props, state) {
    if (props.total !== state.total) {
      props.initPagination(props.location.search, props.total)
      return {
        total: props.total
      }
    }
    return null
  }

  render() {
    return (
      <React.Fragment>
        <h1>{__("Novinky")}</h1>
        {
          this.props.news.map((newsItem, idx) => (
            <NewsItem key={idx} {...newsItem}/>
          ))
        }
        <FlexRow>
          {
            this.props.pages.map((page) => (
              <PaginationButton
                key={page.page}
                onClick={() => this.props.showPage(this.props.history, page.page)}
              >
                {page.name}
              </PaginationButton>
            ))
          }
        </FlexRow>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  ...selectNews(state),
  pages: paginate(state.content.pagination)
})

const mapDispatchToProps = (dispatch) => ({
  initPagination: (queryString, total) => dispatch(initPagination(queryString, total)),
  showPage: (history, page) => dispatch(showPage(history, page))
})

export default connect(mapStateToProps, mapDispatchToProps)(News)
